let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5N9fU")).then(() => parcelRequire('3Bry3'));